// import React, { useState, useEffect } from "react";
// import styles from "../../assets/scss/Billing/Calculate.module.scss";
// import { useLocation, useNavigate } from "react-router-dom";
// import Pagination from "../../Components/Common/Pagination";

// const billData = {
//   storeId: {
//     storeName: "ABC Traders",
//     userId: { phone: "9876543210" },
//   },
//   paymentMethod: "Cash",
//   saleCommission: "percentage",
//   percentage: 5,
//   commissionAmount: 250,
//   handleCharge: 50,
//   logisticCharge: 100,
//   totalAmount: 5350,
//   items: [
//     {
//       _id: "1",
//       productName: "Tomato",
//       itemId: { productBag: "Kg", overallQuantity: 20 },
//       price: 50,
//       totalPrice: 1000,
//     },
//     {
//       _id: "2",
//       productName: "Potato",
//       itemId: { productBag: "Kg", overallQuantity: 30 },
//       price: 40,
//       totalPrice: 1200,
//     },
//     {
//       _id: "3",
//       productName: "Onion",
//       itemId: { productBag: "Kg", overallQuantity: 15 },
//       price: 60,
//       totalPrice: 900,
//     },
//   ],
// };

// const ViewLedgerId = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const searchParams = new URLSearchParams(location.search);
//   const customerId = searchParams.get("id");
//   const journalId = searchParams.get("journalId");
//   const mode = searchParams.get("mode");
//   const [currentPage, setCurrentPage] = useState(1);

//   const [limit, setLimit] = useState(10);
//   const [paginatedItems, setPaginatedItems] = useState([]);

//   const items = billData.items || [];
//   const totalPages = Math.ceil(items.length / limit) || 1;

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * limit;
//     const endIndex = startIndex + limit;
//     setPaginatedItems(items.slice(startIndex, endIndex));
//   }, [currentPage, limit]); 

//   const customerName = billData?.storeId?.storeName || "N/A";
//   const customerPhone = billData?.storeId?.userId?.phone || "N/A";
//   const paymentMethod = billData?.paymentMethod || "N/A";

//   const commissionType = billData?.saleCommission || "-";
//   const commissionValue = billData?.percentage || 0;
//   const commissionAmount = billData?.commissionAmount || 0;
//   const handleCharge = billData?.handleCharge || 0;
//   const logisticCharge = billData?.logisticCharge || 0;
//   const overallTotal = billData?.totalAmount || 0;

//   const handleClose = () => {
//     navigate(`/dashboard/ViewLadger?id=${customerId}&mode=${mode}`);
//   };

//   return (
//     <div className={styles.calculateContainer}>
//       {/* Header */}
//       <div className={styles.header}>
//         <h2 className={styles.tittle}>View Billing Details </h2>
//         <span onClick={handleClose} className={styles.closeIcon}>
//           ✕
//         </span>
//       </div>

//       <div className={styles.padding}>
//         {/* Customer Info */}
//         <div className={styles.formSection}>
//           <div className={styles.inputRow}>
//             <div className={styles.inputGroup}>
//               <label className={styles.inputLabel}>Customer Name</label>
//               <input
//                 className={styles.input}
//                 type="text"
//                 value={customerName}
//                 disabled
//               />
//             </div>
//             <div className={styles.inputGroup}>
//               <label className={styles.inputLabel}>Phone Number</label>
//               <input
//                 className={styles.input}
//                 type="text"
//                 value={customerPhone}
//                 disabled
//               />
//             </div>
//             <div className={styles.inputGroup}>
//               <label className={styles.inputLabel}>Payment Type</label>
//               <input
//                 className={styles.input}
//                 type="text"
//                 value={paymentMethod}
//                 disabled
//               />
//             </div>
//           </div>
//         </div>

//         {/* Items Table */}
//         <div className={styles.itemsSection}>
//           <div className={styles.tableWrapper}>
//             <table>
//               <thead>
//                 <tr>
//                   <th>Item</th>
//                   <th>Category</th>
//                   <th>Price</th>
//                   <th>Qty</th>
//                   <th>Total</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedItems.map((i) => (
//                   <tr key={i._id}>
//                     <td>{i.productName || i.itemId?.productName}</td>
//                     <td>{i.itemId?.productBag || "-"}</td>
//                     <td>₹{i.price}</td>
//                     <td>
//                       {i.itemId?.overallQuantity ||
//                         i.productQuantity ||
//                         i.productCount}
//                     </td>
//                     <td>₹{i.totalPrice}</td>
//                   </tr>
//                 ))}
//                 {paginatedItems.length === 0 && (
//                   <tr>
//                     <td colSpan={7} className={styles.noData}>
//                       No items found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* Pagination */}
//           {items.length > 0 && (
//             <div className={styles.paginationWrapper}>
//               <Pagination
//                 currentPage={currentPage}
//                 totalPages={totalPages}
//                 onPageChange={setCurrentPage}
//               />

//               <select
//                 className={styles.inputsbtn}
//                 value={limit}
//                 onChange={(e) => {
//                   setLimit(Number(e.target.value));
//                   setCurrentPage(1);
//                 }}
//               >
//                 <option value={10}>10 rows</option>
//                 <option value={25}>25 rows</option>
//                 <option value={50}>50 rows</option>
//               </select>
//             </div>
//           )}
//         </div>

//         {/* Charges Section */}
//         <div className={styles.chargesSection}>
//           <div className={styles.inputRows}>
//             <div className={styles.inputGroups}>
//               <label className={styles.inputLabel}>Commission Type : </label>
//               <h2 className={styles.inputones}>{commissionType}</h2>
//             </div>

//             {commissionType === "percentage" && (
//               <div className={styles.inputGroups}>
//                 <label className={styles.inputLabel}>Enter % : </label>
//                 <h2 className={styles.inputones}>{commissionValue}%</h2>
//               </div>
//             )}

//             <div className={styles.inputGroups}>
//               <label className={styles.inputLabel}>Commission Amount : </label>
//               <h2 className={styles.inputones}>₹ {commissionAmount}</h2>
//             </div>

//             <div className={styles.inputGroups}>
//               <label className={styles.inputLabel}>Handling Charge : </label>
//               <h2 className={styles.inputones}>₹ {handleCharge}</h2>
//             </div>
//           </div>

//           <div className={styles.inputRows}>
//             <div className={styles.inputGroups}>
//               <label className={styles.inputLabel}>TransportCharge : </label>
//               <h2 className={styles.inputones}>₹ {logisticCharge}</h2>
//             </div>
//             <div className={styles.inputGroups}>
//               <label className={styles.inputLabel}>Overall Total : </label>
//               <h2 className={styles.inputones}>₹ {overallTotal}</h2>
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         <div className={styles.footerButtons}>
//           <button className={styles.cancelBtn} onClick={handleClose}>
//             Cancel
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ViewLedgerId;

import React, { useState, useEffect } from "react";
import styles from "../../assets/scss/Billing/Calculate.module.scss";
import { useNavigate, useLocation } from "react-router-dom";
import Pagination from "../../Components/Common/Pagination";
import { useGetCustomerJournalsQuery } from "../../slices/admin/admin";

const ViewLedgerId = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const customerId = searchParams.get("id");
  const journalId = searchParams.get("journalId");
  const mode = searchParams.get("mode");

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [paginatedItems, setPaginatedItems] = useState([]);

  const { data, isLoading, isError } = useGetCustomerJournalsQuery(
    { customerId, journalId, offset: 1, limit: 10 },
    { skip: !customerId }
  );

  const currentJournal = data?.journals?.find((j) => j._id === journalId);

  const items = currentJournal?.billItems || [];
  const totalPages = Math.ceil(items.length / limit) || 1;

  useEffect(() => {
    const startIndex = (currentPage - 1) * limit;
    const endIndex = startIndex + limit;
    setPaginatedItems(items.slice(startIndex, endIndex));
  }, [currentPage, limit, items]);

  const customerName = data?.customerDetails?.firstName || "-";
  const customerPhone = data?.customerDetails?.phone || "-";
  const paymentMethod = currentJournal?.paymentMethod || "-";

  const handleCharge = currentJournal?.billingInfo?.handleCharge || 0;
  const logisticCharge = currentJournal?.billingInfo?.logisticCharge || 0;
  const overallTotal = currentJournal?.billingInfo?.totalAmount || 0

  const handleClose = () => {
    navigate(`/dashboard/ViewLadger?id=${customerId}&mode=${mode}`);
  };

  return (
    <div className={styles.calculateContainer}>
      {/* Header */}
      <div className={styles.header}>
        <h2 className={styles.tittle}>View Receivable Billing Details</h2>
        <span onClick={handleClose} className={styles.closeIcon}>
          ✕
        </span>
      </div>

      {isLoading ? (
        <p>Loading...</p>
      ) : isError ? (
        <p>Error loading data</p>
      ) : !currentJournal ? (
        <p>No journal found</p>
      ) : (
        <div className={styles.padding}>
          {/* Customer Info */}
            {/* <div className={styles.inputRow}>
              <div className={styles.inputGroup}>
                <label className={styles.inputLabel}>Customer Name</label>
                <input className={styles.input} type="text" value={customerName} disabled />
              </div>
              <div className={styles.inputGroup}>
                <label className={styles.inputLabel}>Phone Number</label>
                <input className={styles.input} type="text" value={customerPhone} disabled />
              </div>
              <div className={styles.inputGroup}>
                <label className={styles.inputLabel}>Payment Type</label>
                <input className={styles.input} type="text" value={paymentMethod} disabled />
              </div>
            </div> */}
            <div className={styles.ownerBox}>
              <p>
                <strong>Item Owner :</strong> {customerName || "-"}
              </p>
              <p>
                <strong>Phone No :</strong> {customerPhone || "-"}
              </p>
              <p>
                <strong>Payment Method :</strong> {paymentMethod || "-"}
              </p>
            </div>

          {/* Items Table */}
          <div className={styles.itemsSection}>
            <div className={styles.tableWrapper}>
              <table>
                <thead>
                  <tr>
                    <th>Item</th>
                    {/* <th>Category</th> */}
                    <th>Price</th>
                    <th>Qty</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedItems.map((i) => (
                    <tr key={i._id}>
                      <td>{i.productName}</td>
                      {/* <td>{i.productQuality || "-"}</td> */}
                      <td>₹{i.price}</td>
                      <td>{i.productQuantity}</td>
                      <td>₹{i.totalPrice}</td>
                    </tr>
                  ))}
                  {paginatedItems.length === 0 && (
                    <tr>
                      <td colSpan={5} className={styles.noData}>
                        No items found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {items.length > 0 && (
              <div className={styles.paginationWrapper}>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
                <select
                  className={styles.inputsbtn}
                  value={limit}
                  onChange={(e) => {
                    setLimit(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  <option value={10}>10 rows</option>
                  <option value={25}>25 rows</option>
                  <option value={50}>50 rows</option>
                </select>
              </div>
            )}
          </div>

          {/* Charges Section */}
          {/* Charges Section */}
          <div className={styles.chargesSection}>
            <div className={styles.inputRows}>
              <div className={styles.inputGroups}>
                <label className={styles.inputLabel}>Handle Charge : </label>
                <h2 className={styles.inputones}>₹ {handleCharge}</h2>
              </div>
              <div className={styles.inputGroups}>
                <label className={styles.inputLabel}>Logistic Charge : </label>
                <h2 className={styles.inputones}>₹ {logisticCharge}</h2>
              </div>
              <div className={styles.inputGroups}>
                {/* <label className={styles.inputLabel}>Overall Total : </label>
                <h2 className={styles.inputones}>₹ {overallTotal}</h2> */}
              </div>
              <div className={styles.inputGroups}>
                <label className={styles.inputLabel}>Overall Total : </label>
                <h2 className={styles.inputones}>₹ {overallTotal}</h2>
              </div>
            </div>
          </div>


          {/* Footer */}
          <div className={styles.footerButtons}>
            <button className={styles.cancelBtn} onClick={handleClose}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewLedgerId;
